export const apiReferenceContent = `
Integrate Reqqy into your CI/CD pipeline, project management tools, or custom workflows with our REST API.

{% endpoint method="POST" path="/api/v1/reviews" description="Submit requirements for review" /%}
{% endpoint method="GET" path="/api/v1/reviews/:id" description="Retrieve review results" /%}
{% endpoint method="GET" path="/api/v1/projects" description="List all projects" /%}
{% endpoint method="POST" path="/api/v1/projects" description="Create a new project" /%}
{% endpoint method="GET" path="/api/v1/personas" description="List available personas" /%}
{% endpoint method="GET" path="/api/v1/credits/balance" description="Check credit balance" /%}

{% callout type="info" title="Authentication" %}
All API requests require a Bearer token in the Authorization header. Generate API keys from your [Settings](/settings) page.
{% /callout %}
`;
